import {useQuery} from "@tanstack/react-query";
import {queryKeys} from "../react-query/constant";
import getAgentInfo from "../api/agentInfo";

const useAgentInfo =()=>{
    return useQuery([queryKeys.agentInfo],getAgentInfo,{
        onError: (error) => console.log(error)
    })
}
export default useAgentInfo